/**
 * Pestanas plegables de la pagina de producto.
 *
 * El tema fija la altura de apertura (--tab-height) una sola vez al enlazar
 * los inputs. Eso falla en tres casos: contenido con imagenes que cargan
 * despues (guia de tallas), contenido que se reescribe al cambiar de variante,
 * y bloques reinyectados por el editor de temas. Aqui se recalcula por
 * delegacion de eventos, asi que funciona en los tres.
 *
 * Ademas, si el contenedor declara data-tabs-exclusive, al abrir una pestana
 * se cierran las demas.
 */
(function () {
  var ITEM = '.tab-accordion-item';
  var BOX = '.js-set-height';

  function setHeight(box) {
    if (!box) return;
    box.style.setProperty('--tab-height', box.scrollHeight + 'px');
  }

  function boxOf(input) {
    var item = input.closest(ITEM);
    return item ? item.querySelector(BOX) : null;
  }

  /** Reajusta cuando terminan de cargar las imagenes del contenido. */
  function watchImages(box) {
    if (!box) return;

    box.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () { setHeight(box); }, { once: true });
      img.addEventListener('error', function () { setHeight(box); }, { once: true });
    });
  }

  function closeOthers(input) {
    var scope = input.closest('[data-tabs-exclusive]');
    if (!scope) return;

    scope.querySelectorAll('input[name="tab-accordion"]').forEach(function (other) {
      if (other === input || !other.checked) return;
      other.checked = false;
      setHeight(boxOf(other));
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[name="tab-accordion"]')) return;

    var box = boxOf(input);
    if (!box) return;

    if (input.checked) closeOthers(input);

    setHeight(box);
    watchImages(box);
  });

  /** Contenido que cambia de alto con la pestana ya abierta. */
  function observeAll() {
    if (!('ResizeObserver' in window)) return;

    if (!observeAll.ro) {
      observeAll.ro = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          setHeight(entry.target.closest(BOX));
        });
      });
    }

    document.querySelectorAll(BOX + ' > *').forEach(function (child) {
      observeAll.ro.observe(child);
    });
  }

  function init() {
    observeAll();
    document.querySelectorAll(BOX).forEach(watchImages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
